<template>
  <div>
    <TheOffice v-if="!user_info.dirty && user_info.data.space_id"/>
    <TheIntro v-else-if="!user_info.dirty"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import TheIntro from '@/views/cabinet/TheIntro.vue'
import TheOffice from '@/views/cabinet/Money/TheDashboard.vue'

export default {
  name: "TheSpace",
  components: {TheIntro, TheOffice},
  computed: {
    ...mapState('cabinet/user', ['user_info'])
  }
}
</script>
